import type { FC, PropsWithChildren } from 'react';
import { useReportLoading } from 'features/loading';
import { useSetupNetworkStatus } from 'features/network/useSetupNetworkStatus';
import { NetworkStatusContext } from './NetworkStatusContext';

export const NetworkStatusProvider: FC<PropsWithChildren> = ({ children }) => {
  const { isOnline, initialized: networkStatusInitialized } =
    useSetupNetworkStatus();

  useReportLoading(!networkStatusInitialized);

  return (
    <NetworkStatusContext.Provider value={{ isOnline }}>
      {networkStatusInitialized ? children : null}
    </NetworkStatusContext.Provider>
  );
};
